import { ObservabilityErrorSeverity } from '@Services/observability/initObservability';
import type { Options } from 'html2canvas';

export const IMAGE_FORMAT = 'image/jpeg' as const;
export const IMAGE_QUALITY = 0.85;

export const MEMORY_OPTIMIZED_OPTIONS = {
  scale: IMAGE_QUALITY,
  ignoreElements: (element: Element) => {
    return element.tagName === 'SCRIPT' || element.tagName === 'NOSCRIPT';
  },
} as const satisfies Partial<Options>;

export const cleanupCanvas = (canvas: HTMLCanvasElement) => {
  try {
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    canvas.remove();
  } catch (error) {
    reportError({
      metadata: {
        name: 'Canvas Cleanup Error',
        message: `${error instanceof Error ? error.message : String(error)} | Canvas: ${canvas.width}x${canvas.height}`,
      },
      severity: ObservabilityErrorSeverity.ERROR,
    });
  }
};
